import { defineMessages } from 'react-intl';

export default defineMessages({
  initializing: {
    id: 'cboard.components.UI.Downloader.initializing',
    defaultMessage: 'Initializing...'
  },
  completed: {
    id: 'cboard.components.UI.Downloader.completed',
    defaultMessage: 'Completed'
  },
  processing: {
    id: 'cboard.components.UI.Downloader.processing',
    defaultMessage: 'Processing...'
  },
  processingDone: {
    id: 'cboard.components.UI.Downloader.processingDone',
    defaultMessage: 'Process Done!'
  },
  processingError: {
    id: 'cboard.components.UI.Downloader.processingError',
    defaultMessage: 'There was an error processing the data, please try again.'
  }
});
